import { ReactNode } from 'react';
import './style.scss';
import { cn } from '@/utils/utils';
import { useLocation } from 'react-router-dom';
import { isPathEk } from '@/utils/routes';
import { kickboardClassName } from '@/configs/constants';

// #region Sub Title With 2 Box
interface SubTitleWithTwoBoxProps {
    sub: string | ReactNode,
    title: string | ReactNode,
    parentClassName?: string,
    subClassName?: string,
    titleClassName?: string
}
const SubTitleWithTwoBox = ({
    sub = '',
    title = '',
    parentClassName,
    subClassName,
    titleClassName
}: SubTitleWithTwoBoxProps) => {
    const { pathname } = useLocation();
    const isEk = isPathEk(pathname);
    return (
        <div
            className={cn('sec-title', isEk && kickboardClassName, parentClassName)}
        >
            <p
                className={cn(
                    'sub relative text-[min(12px,3.2vw)] leading-[calc(18/12)] sm:text-fs-mid14 sm:leading-lh-mid14 text-primaryWeb uppercase font-normal',
                    subClassName
                )}
            >
                {sub}
            </p>
            <h3
                className={cn(
                    'title font-semibold mt-[10px] text-[24px] leading-[calc(30/24)] sm:text-head2 sm:leading-lh-mid34 lg:text-page-title lg:leading-lh-mid36',
                    titleClassName
                )}
            >
                {title}
            </h3>
        </div>
    );
};
// #endregion Sub Title With 2 Box

// #region Sub Title With 1 Box
interface SubTitleWithBoxProps {
    title: string | ReactNode,
    parentClassName?: string,
    titleClassName?: string
}
const SubTitleWithBox = ({
    title = '',
    parentClassName,
    titleClassName
}: SubTitleWithBoxProps) => {
    return (
        <div className={cn(
            'flex items-center gap-1',
            parentClassName
        )}
        >
            <div className='size-3 bg-primaryWeb' />
            <p className={cn(
                'text-fs-mid14 leading-lh-mid14 font-semibold',
                titleClassName
            )}
            >
                {title}
            </p>
        </div>
    );
};
// #endregion Sub Title With 1 Box

export { SubTitleWithTwoBox, SubTitleWithBox };
